(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AreaService', AreaService);

    AreaService.$inject = ['$http', 'API_URL'];

    function AreaService ($http, API_URL) {
        var service = {
            areaInfo: areaInfo,
            loadPrices : loadPrices,
            loadLabels: loadLabels,
            loadBookingOptions: loadBookingOptions,
            loadCartLabels: loadCartLabels
        };

        return service;


        function areaInfo() {
            return $http.get(API_URL + 'area');
        }

        function loadPrices(key) {
            return $http.get(API_URL + 'area/prices', {params:{key:key}});
        }
        
        function loadLabels(key) {
            return $http.get(API_URL + 'project/translations', {params:{key:key}});
        }

        function loadBookingOptions(key) {
            return $http.get(API_URL + 'area/bookingoptions', {params:{key:key}});
        }

        function loadCartLabels(key) {
            return $http.get(API_URL + 'area/cartlabel', {params:{key:key}});
        }
    }
})();
